import React from "react";
import { useTheme } from "../../context/ThemeContext";
import Tooltip from "../common/Tooltip";

const PartnerLogos: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="bg-white dark:bg-gray-900 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-2">
          <div className="flex justify-between items-center">
            <div className="flex-shrink-0">
              <img
                src={
                  theme === "light"
                    ? "/autofront_light.png"
                    : "/autofront_dark.png"
                }
                alt="Partner Logo"
                className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200"
                loading="lazy"
                decoding="async"
                width="120"
                height="32"
              />
            </div>
            {/* Version Badge */}
            <Tooltip
              content={`Build: ${process.env.REACT_APP_BUILD_DATE || 'Development'}`}
              position="bottom"
            >
              <div className="px-2 py-1 bg-gray-100 dark:bg-gray-800 rounded-full cursor-help">
                <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
                  v{process.env.REACT_APP_VERSION || '1.0.0'}
                </span>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerLogos;
